import React, {useEffect, useState} from "react";
import {connect, useDispatch} from "react-redux";
import {isTimeNotUp} from "../../../helper";
import ButtonComponent from "../../button/buttonComponent";
import {updateSeasonPlayerStatsInit} from "../../../services/seasonService";
import ConfirmationTxtLbComponent from "../../layout/confirmationTxtLbComponent";
import NbaPlayoffInputItemComponent from "../../input/nbaPlayoff/nbaPlayoffInputItemComponent";
import {nbaPlayoffSeriesInputOptions} from "../../../constants/variables";

function NbaSecondRoundPredictionsFormComponent(props) {
    const dispatch = useDispatch();
    const [buttonsDisabled, setButtonsDisabled] = useState(false);
    const [confirmationTxt, setConfirmationTxt] = useState(null);

    const [predictionsLb, setPredictionsLb] = useState(null);
    const [statisticsLb, setStatisticsLb] = useState(null);

    const [east_1_8_vs_4_5_prediction, set_east_1_8_vs_4_5_prediction] = useState(null);
    const [east_2_7_vs_3_6_prediction, set_east_2_7_vs_3_6_prediction] = useState(null);
    const [west_1_8_vs_4_5_prediction, set_west_1_8_vs_4_5_prediction] = useState(null);
    const [west_2_7_vs_3_6_prediction, set_west_2_7_vs_3_6_prediction] = useState(null);
    const [scorer_prediction, set_scorer_prediction] = useState(null);

    const [is_east_1_8_vs_4_5_active, set_east_1_8_vs_4_5_active] = useState("");
    const [is_east_2_7_vs_3_6_active, set_east_2_7_vs_3_6_active] = useState("");
    const [is_west_1_8_vs_4_5_active, set_west_1_8_vs_4_5_active] = useState("");
    const [is_west_2_7_vs_3_6_active, set_west_2_7_vs_3_6_active] = useState("");
    const [is_scorer_active, set_scorer_active] = useState("");

    useEffect(() => {
        if (props.playerStats) {

            if (props.playerStats.second_round_predictions.east_1_8_vs_4_5) {
                const value = props.playerStats.second_round_predictions.east_1_8_vs_4_5;
                set_east_1_8_vs_4_5_prediction({
                    value: value,
                    label: value.split("_")[1] + "-" + value.split("_")[2],
                })
            }

            if (props.playerStats.second_round_predictions.east_2_7_vs_3_6) {
                const value = props.playerStats.second_round_predictions.east_2_7_vs_3_6;
                set_east_2_7_vs_3_6_prediction({
                    value: value,
                    label: value.split("_")[1] + "-" + value.split("_")[2],
                })
            }

            if (props.playerStats.second_round_predictions.west_1_8_vs_4_5) {
                const value = props.playerStats.second_round_predictions.west_1_8_vs_4_5;
                set_west_1_8_vs_4_5_prediction({
                    value: value,
                    label: value.split("_")[1] + "-" + value.split("_")[2],
                })
            }

            if (props.playerStats.second_round_predictions.west_2_7_vs_3_6) {
                const value = props.playerStats.second_round_predictions.west_2_7_vs_3_6;
                set_west_2_7_vs_3_6_prediction({
                    value: value,
                    label: value.split("_")[1] + "-" + value.split("_")[2],
                })
            }

            if (props.playerStats.second_round_predictions.scorer) {
                set_scorer_prediction({
                    value: props.playerStats.second_round_predictions.scorer,
                    label: props.playerStats.second_round_predictions.scorer,
                })
            }
        }
    }, [props.playerStats]);

    useEffect(() => {
        setStartTimeActives();
    }, [props.season.info]);

    useEffect(() => {
        setStartTimeActives();
    }, []);

    const setStartTimeActives = () => {
        if (props.season.info) {
            props.season.info.second_round.east_1_8_vs_4_5.start_time && set_east_1_8_vs_4_5_active(isTimeNotUp(props.season.now, props.season.info.second_round.east_1_8_vs_4_5.start_time))
            props.season.info.second_round.east_2_7_vs_3_6.start_time && set_east_2_7_vs_3_6_active(isTimeNotUp(props.season.now, props.season.info.second_round.east_2_7_vs_3_6.start_time))
            props.season.info.second_round.west_1_8_vs_4_5.start_time && set_west_1_8_vs_4_5_active(isTimeNotUp(props.season.now, props.season.info.second_round.west_1_8_vs_4_5.start_time))
            props.season.info.second_round.west_2_7_vs_3_6.start_time && set_west_2_7_vs_3_6_active(isTimeNotUp(props.season.now, props.season.info.second_round.west_2_7_vs_3_6.start_time))
            props.season.info.second_round.scorer.start_time && set_scorer_active(isTimeNotUp(props.season.now, props.season.info.second_round.scorer.start_time))
        }
    }

    const submitPredictions = () => {
        setButtonsDisabled(true)

        const newPlayerStats = structuredClone(props.playerStats);

        newPlayerStats.second_round_predictions = {
            east_1_8_vs_4_5: east_1_8_vs_4_5_prediction ? east_1_8_vs_4_5_prediction.value : null,
            east_2_7_vs_3_6: east_2_7_vs_3_6_prediction ? east_2_7_vs_3_6_prediction.value : null,
            west_1_8_vs_4_5: west_1_8_vs_4_5_prediction ? west_1_8_vs_4_5_prediction.value : null,
            west_2_7_vs_3_6: west_2_7_vs_3_6_prediction ? west_2_7_vs_3_6_prediction.value : null,
            scorer: scorer_prediction ? scorer_prediction.value : null,
        };

        updateSeasonPlayerStatsInit(props.season.type, newPlayerStats, dispatch).then(_ => {
            setButtonsDisabled(false);
            setConfirmationTxt("İkinci tur tahminlerin kaydedildi.")
        });
    }

    return (
        <form onSubmit={(e) => e.preventDefault()}>

            {
                props.season.info.second_round.east_1_8_vs_4_5.start_time && props.seasonStats &&
                <NbaPlayoffInputItemComponent
                    is_active={is_east_1_8_vs_4_5_active}
                    inputValue={east_1_8_vs_4_5_prediction}
                    setInputValue={set_east_1_8_vs_4_5_prediction}
                    inputName={"east_1_8_vs_4_5"}
                    labelText={`${props.season.info.second_round.east_1_8_vs_4_5.team_1} vs. ${props.season.info.second_round.east_1_8_vs_4_5.team_2}`}
                    stats={props.seasonStats.statistics.second_round.east_1_8_vs_4_5}
                    predictions={props.seasonStats.playersPredictions.second_round.east_1_8_vs_4_5}
                    info={props.season.info.second_round.east_1_8_vs_4_5}
                    inputOptions={nbaPlayoffSeriesInputOptions}
                    setStatisticsLb={setStatisticsLb}
                    statisticsLb={statisticsLb}
                    setPredictionsLb={setPredictionsLb}
                    predictionsLb={predictionsLb}
                    buttonsDisabled={buttonsDisabled}
                />
            }

            {
                props.season.info.second_round.east_2_7_vs_3_6.start_time && props.seasonStats &&
                <NbaPlayoffInputItemComponent
                    is_active={is_east_2_7_vs_3_6_active}
                    inputValue={east_2_7_vs_3_6_prediction}
                    setInputValue={set_east_2_7_vs_3_6_prediction}
                    inputName={"east_2_7_vs_3_6"}
                    labelText={`${props.season.info.second_round.east_2_7_vs_3_6.team_1} vs. ${props.season.info.second_round.east_2_7_vs_3_6.team_2}`}
                    stats={props.seasonStats.statistics.second_round.east_2_7_vs_3_6}
                    predictions={props.seasonStats.playersPredictions.second_round.east_2_7_vs_3_6}
                    info={props.season.info.second_round.east_2_7_vs_3_6}
                    inputOptions={nbaPlayoffSeriesInputOptions}
                    setStatisticsLb={setStatisticsLb}
                    statisticsLb={statisticsLb}
                    setPredictionsLb={setPredictionsLb}
                    predictionsLb={predictionsLb}
                    buttonsDisabled={buttonsDisabled}
                />
            }

            {
                props.season.info.second_round.west_1_8_vs_4_5.start_time && props.seasonStats &&
                <NbaPlayoffInputItemComponent
                    is_active={is_west_1_8_vs_4_5_active}
                    inputValue={west_1_8_vs_4_5_prediction}
                    setInputValue={set_west_1_8_vs_4_5_prediction}
                    inputName={"west_1_8_vs_4_5"}
                    labelText={`${props.season.info.second_round.west_1_8_vs_4_5.team_1} vs. ${props.season.info.second_round.west_1_8_vs_4_5.team_2}`}
                    stats={props.seasonStats.statistics.second_round.west_1_8_vs_4_5}
                    predictions={props.seasonStats.playersPredictions.second_round.west_1_8_vs_4_5}
                    info={props.season.info.second_round.west_1_8_vs_4_5}
                    inputOptions={nbaPlayoffSeriesInputOptions}
                    setStatisticsLb={setStatisticsLb}
                    statisticsLb={statisticsLb}
                    setPredictionsLb={setPredictionsLb}
                    predictionsLb={predictionsLb}
                    buttonsDisabled={buttonsDisabled}
                />
            }

            {
                props.season.info.second_round.west_2_7_vs_3_6.start_time && props.seasonStats &&
                <NbaPlayoffInputItemComponent
                    is_active={is_west_2_7_vs_3_6_active}
                    inputValue={west_2_7_vs_3_6_prediction}
                    setInputValue={set_west_2_7_vs_3_6_prediction}
                    inputName={"west_2_7_vs_3_6"}
                    labelText={`${props.season.info.second_round.west_2_7_vs_3_6.team_1} vs. ${props.season.info.second_round.west_2_7_vs_3_6.team_2}`}
                    stats={props.seasonStats.statistics.second_round.west_2_7_vs_3_6}
                    predictions={props.seasonStats.playersPredictions.second_round.west_2_7_vs_3_6}
                    info={props.season.info.second_round.west_2_7_vs_3_6}
                    inputOptions={nbaPlayoffSeriesInputOptions}
                    setStatisticsLb={setStatisticsLb}
                    statisticsLb={statisticsLb}
                    setPredictionsLb={setPredictionsLb}
                    predictionsLb={predictionsLb}
                    buttonsDisabled={buttonsDisabled}
                />
            }

            {
                props.season.info.second_round.scorer.start_time && props.seasonStats &&
                <NbaPlayoffInputItemComponent
                    is_active={is_scorer_active}
                    inputValue={scorer_prediction}
                    setInputValue={set_scorer_prediction}
                    inputName={"scorer"}
                    labelText={`İkinci Turun En Skorer Oyuncusu`}
                    predictions={props.seasonStats.playersPredictions.second_round.scorer}
                    info={props.season.info.second_round.scorer}
                    inputOptions={props.season.info.second_round.scorer.list.sort().map(x => ({value: x, label:x}))}
                    setPredictionsLb={setPredictionsLb}
                    predictionsLb={predictionsLb}
                    buttonsDisabled={buttonsDisabled}
                    stats={props.seasonStats.statistics.second_round.scorer}
                    setStatisticsLb={setStatisticsLb}
                    statisticsLb={statisticsLb}
                />
            }

            {
                props.playerStats && (
                    is_east_1_8_vs_4_5_active ||
                    is_east_2_7_vs_3_6_active ||
                    is_west_1_8_vs_4_5_active ||
                    is_west_2_7_vs_3_6_active ||
                        is_scorer_active
                ) &&

                <ButtonComponent type="submit" text={"Kaydet"} onClick={submitPredictions}
                                 isDisabled={buttonsDisabled}/>
            }

            {
                confirmationTxt &&
                <ConfirmationTxtLbComponent text={confirmationTxt} setConfirmationTxt={setConfirmationTxt}/>
            }

        </form>
    );
}

const mapStateToProps = (state) => ({
    season: state.seasonReducer.season,
    playerStats: state.seasonReducer.playerStats,
    allPlayersStats: state.seasonReducer.allPlayersStats,
    seasonStats: state.seasonReducer.seasonStats,
})

export default connect(mapStateToProps)(NbaSecondRoundPredictionsFormComponent);